import { AxiosResponse } from 'axios'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import { outlookDisplayNewMessageForm } from '../../../helpers/outlookHelper'
import useAxios from '../../../hooks/useAxios'
import { getDownloadUrl } from '../../../helpers/documentHelper'
import { useSettings } from '../../useSettings'

export default function useComposeInvoiceOutlookMessage() {
    const axios = useAxios()
    const settings = useSettings()

    return async (invoiceId: string, recipientEmail: string, pdf: DriveItem) => {
        const message: AxiosResponse<{
            body: string
            subject: string
        }> = await axios.get(`/finance/invoice/${invoiceId}/message`)

        outlookDisplayNewMessageForm({
            toRecipients: recipientEmail.split(/[,;]/),
            bccRecipients: settings.invoiceEmailBcc,
            subject: message.data.subject,
            attachments: [
                {
                    type: 'file',
                    name: pdf.name,
                    url: getDownloadUrl(pdf),
                    isInline: false,
                },
            ],
            htmlBody: message.data.body,
        })
    }
}
